var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fill-height":""}},[_c('v-row',{staticClass:"justify-center align-center ma-0 pa-0"},[_c('file-preview',{attrs:{"file":_vm.loadedFile,"width":_vm.width,"height":_vm.height}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }